const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0625 1.875H15.9375V4.6875H14.0625V1.875Z",
  fill: "#5B5B5F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3125 14.0625H28.125V15.9375H25.3125V14.0625Z",
  fill: "#5B5B5F"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0625 25.3125H15.9375V28.125H14.0625V25.3125Z",
  fill: "#5B5B5F"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.875 14.0625H4.6875V15.9375H1.875V14.0625Z",
  fill: "#5B5B5F"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.10938 6.45376L6.435 5.1272L8.42344 7.11657L7.09781 8.4422L5.10938 6.45376Z",
  fill: "#5B5B5F"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5625 7.10627L23.5509 5.11877L24.8766 6.4444L22.8881 8.43284L21.5625 7.10627Z",
  fill: "#5B5B5F"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5644 22.89L22.8909 21.5643L24.8784 23.5537L23.5537 24.8793L21.5644 22.89Z",
  fill: "#5B5B5F"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.12811 23.5594L7.11561 21.5625L8.43749 22.8938L6.44999 24.8813L5.12811 23.5594V23.5594Z",
  fill: "#5B5B5F"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15 7.5C13.5166 7.5 12.0666 7.93987 10.8332 8.76398C9.59986 9.58809 8.63856 10.7594 8.07091 12.1299C7.50325 13.5003 7.35472 15.0083 7.64411 16.4632C7.9335 17.918 8.64781 19.2544 9.6967 20.3033C10.7456 21.3522 12.082 22.0665 13.5368 22.3559C14.9917 22.6453 16.4997 22.4968 17.8701 21.9291C19.2406 21.3614 20.4119 20.4001 21.236 19.1668C22.0601 17.9334 22.5 16.4834 22.5 15C22.5 13.0109 21.7098 11.1032 20.3033 9.6967C18.8968 8.29018 16.9891 7.5 15 7.5ZM15 20.625C13.5082 20.625 12.0774 20.0324 11.0225 18.9775C9.96764 17.9226 9.375 16.4918 9.375 15C9.375 13.5082 9.96764 12.0774 11.0225 11.0225C12.0774 9.96763 13.5082 9.375 15 9.375V20.625Z",
  fill: "#5B5B5F"
});
const SvgContraste = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContraste, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contraste.e0142291.svg";
export { ForwardRef as ReactComponent };